export const getSelectedPaymentTypeCode = (
  selectedPaymentMethod: string | undefined,
  selectedEWallet: string | undefined,
): string => {
  if (selectedPaymentMethod === 'ewallet') {
    return selectedEWallet ?? '';
  }
  return selectedPaymentMethod ?? '';
};
